module.exports = __webpack_public_path__ + "img/Gruppenführer_Technik_und_Sicherheit.78c8d2ef.svg";